import { createSlice } from '@reduxjs/toolkit';
import { buildMenuIndex } from '../../utils/menuOrder';

// The cart lists in menu order (spec 2026-10-12 §4.3) from the menu of the
// basket's store. One index per store slug; the most recently fetched
// stores are kept, because the cart sidebar can show store A's basket while
// store B's menu is open (CartSidebar's CrossStoreBanner). Persisted with
// the basket (store/index.js whitelist), so a reload straight into
// /<slug>/payment still sorts before any menu fetch.
export const MENU_INDEX_STORE_LIMIT = 3;

const initialState = { byStore: {}, recent: [] };

export const menuOrderSlice = createSlice({
  name: 'menuOrder',
  initialState,
  reducers: {
    setMenuIndex: (state, action) => {
      const { slug, index } = action.payload || {};
      if (!slug || !index) return;
      // The 60 s menu poll refetches an unchanged menu: no new state, so
      // nothing that reads the index re-renders.
      if (
        state.recent[0] === slug &&
        JSON.stringify(state.byStore[slug]) === JSON.stringify(index)
      ) {
        return;
      }
      state.byStore[slug] = index;
      state.recent = [slug, ...state.recent.filter((s) => s !== slug)];
      state.recent.slice(MENU_INDEX_STORE_LIMIT).forEach((s) => {
        delete state.byStore[s];
      });
      state.recent = state.recent.slice(0, MENU_INDEX_STORE_LIMIT);
    },
  },
});

export const { setMenuIndex } = menuOrderSlice.actions;

// What every menu fetch dispatches (StoreMenuList, Payment's stock check,
// the product page).
export const menuIndexFetched = (slug, menus) =>
  setMenuIndex({ slug, index: buildMenuIndex(menus) });

export const selectMenuIndex = (state, slug) =>
  (slug && state?.menuOrder?.byStore?.[slug]) || null;

export default menuOrderSlice.reducer;
